module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "verifyOTPDialog",
    attrs: {
      "id": "verify-otp-dialog",
      "top": "30vh",
      "width": "50rem",
      "title": "Profile Verification",
      "visible": _vm.showVerifyOTPDialog,
      "destroy-on-close": true,
      "append-to-body": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showVerifyOTPDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "verificationForm",
    staticClass: "verification-form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.verificationForm
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('p', [_vm._v("Please provide the mobile number of the person who requested profile enhancement.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Number",
      "prop": "mobile",
      "error": _vm.mobileError
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', [_vm._v("\n            Mobile Number\n            "), _c('i', {
          staticClass: "el-icon-phone",
          staticStyle: {
            "color": "#909399",
            "margin-left": "5px"
          }
        })])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "clearable": "",
      "oninput": "this.value = this.value.replace(/[^0-9]/g, '');",
      "placeholder": "Enter Mobile Number",
      "disabled": _vm.otpSent
    },
    on: {
      "blur": _vm.validateMobileNumber,
      "input": _vm.handleMobileNumberInput
    },
    model: {
      value: (_vm.verificationForm.mobile_number),
      callback: function($$v) {
        _vm.$set(_vm.verificationForm, "mobile_number", $$v)
      },
      expression: "verificationForm.mobile_number"
    }
  })], 1)], 1), _vm._v(" "), (_vm.otpSent) ? _c('div', {
    staticClass: "fixed-otp-height"
  }, [_c('p', [_vm._v("Please enter the 5-digit OTP sent to the above mobile number:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "OTP",
      "prop": "otp",
      "error": _vm.otpError
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', [_vm._v("OTP\n            "), _c('i', {
          staticClass: "el-icon-key",
          staticStyle: {
            "color": "#909399",
            "margin-left": "5px"
          }
        })])]
      },
      proxy: true
    }], null, false, 2029356969)
  }, [_vm._v(" "), _c('el-input', {
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "clearable": "",
      "type": _vm.showPassword ? 'text' : 'password',
      "maxlength": "5",
      "oninput": "this.value = this.value.replace(/[^0-9]/g, '');",
      "placeholder": "Enter OTP"
    },
    on: {
      "input": _vm.clearOtpError
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.showPassword) ? _c('el-button', {
          on: {
            "click": _vm.togglePasswordVisibility
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-eye-slash"
        })]) : _c('el-button', {
          on: {
            "click": _vm.togglePasswordVisibility
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-eye"
        })])]
      },
      proxy: true
    }], null, false, 1972162027),
    model: {
      value: (_vm.verificationForm.otp),
      callback: function($$v) {
        _vm.$set(_vm.verificationForm, "otp", $$v)
      },
      expression: "verificationForm.otp"
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCountdown),
      expression: "showCountdown"
    }],
    staticClass: "text-muted",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "countdown"
    }
  }, [_vm._v("\n        Time remaining: " + _vm._s(_vm.countdown) + "\n      ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResend),
      expression: "showResend"
    }],
    staticClass: "text-muted",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "resend"
    }
  }, [_vm._v("\n        Didn't receive OTP? "), _c('a', {
    on: {
      "click": _vm.resendOTP
    }
  }, [_vm._v("Resend")])])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "danger",
      "size": "small",
      "icon": "el-icon-close",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.otpSent) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "success",
      "size": "small",
      "icon": "el-icon-success",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.verifyOTP
    }
  }, [_vm._v("Verify OTP")]) : _vm._e(), _vm._v(" "), (!_vm.otpSent) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-message",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Send OTP")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1736c4d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/profile/dialogs/VerifyOTPDialog.vue
// module id = 3156
// module chunks = 3